import type { NotificationSearchRequestDto } from '../types/search-request.dto';
import type { NotificationSearchRequestModel } from '../types/search-request.model';

import { toSearchRequestDto } from '@/features/Shared/model/mappers/search-request.dt';

export const toNotificationSearchRequestDto = (
	model: NotificationSearchRequestModel
): NotificationSearchRequestDto => {
	return {
		...toSearchRequestDto(model),
		title: model.title,
		only_scheduled: model.onlyScheduled,
	};
};
